function getMaxCharValidator(limit) {
  return {
    validate: 'regex_excludes',
    regex: `^.{${limit + 1},}$`,
    error: `Maximum length exceeded - must be ${limit} characters or less`,
  }
}

export default getMaxCharValidator
